module.exports = __webpack_public_path__ + "img/analytic_telegram.c68ed05c.svg";